/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace */

import { Injectable }           from '@angular/core';
import { HttpClient, HttpParams }                                from '@angular/common/http';
import { first }                 from "rxjs/operators";

import { HttpHeaders }           from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { User }                  from '@/models/user';
import { Logger }                from "@/util/logger";


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class BigQueryService
 *
 * Remote access to BigQuery
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class BigQueryService {

  private userid: string = '';

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    this.userid = user.username;

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** run a BigQuery SQL query, and dump results into a temporary table...and return the temporary table ID */
  public runQuery(query: string): Promise<string> {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    headers.set('Content-Type', 'text/plain');

    return new Promise((resolve, reject) => {

      Logger.debug('[bigquery] runQuery - query...');

      this.http.post<string>(`/backend/bigquery/run`, query, {
        headers,
      }).pipe(first())
        .subscribe(
          (result: any) => {

            Logger.debug('[bigquery] runQuery - received: ', result);

            let table: string = result.temporary_table;

            Logger.debug('[bigquery] runQuery - table: ', table);

            /* pass back the table */

            resolve(table);
          },
          (error) => {

            Logger.debug('[bigquery] runQuery - error: ', error);

            /* bail! */

            reject(error);
          });
    });
  }

  /**
   *
   *  extract the table from BigQuery to Google storage. table is the fully qualified ID of the table,
   * and storage is the "gs://" style URL of where to store it.  That destination can't already exist.
   *
   */
  public extract(table: string, storage: string): Promise<string> {
    const headers = this.headers();

    if (!headers) {

      return null;
    }

    const spec = {
      table:  table,
      url:    storage
    };

    return new Promise((resolve, reject) => {

      Logger.debug(`[bigquery] extract - ${table} => ${storage}...`);

      this.http.put<string>(`/backend/bigquery/extract/table`, spec, {
        headers,
      }).pipe(first())
        .subscribe(
          (result: any) => {

            Logger.debug('[bigquery] extract - received: ', result);

            let storage: string = result.storage;

            Logger.debug('[bigquery] extract - table: ', table);

            /* pass back the google storage URL */

            resolve(storage);
          },
          (error) => {

            Logger.debug('[bigquery] extract - error: ', error);

            /* bail! */

            reject(error);
          });
    });
  }
}
